const SESSION_KEY = 'cc_session';
const USER_KEY = 'cc_user';

export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveSession(session: any, user: any) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch { /* Safari private mode / quota exceeded — session lives in memory only */ }
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_KEY);
  } catch { /* non-fatal */ }
}

export function getToken() {
  const session = getSession();
  return session?.access_token || null;
}

export function isAuthenticated() {
  const session = getSession();
  if (!session) return false;
  const expiry = session.expires_at;
  if (expiry && Date.now() / 1000 > expiry) {
    clearSession();
    return false;
  }
  return true;
}
